import React, { useState } from 'react'
import {
    CRow,
    CCol,
    CCard,
    CCardHeader,
    CCardBody,
    CBadge,
    CFormGroup,
    CInputGroup,
    CInput,
    CInputGroupPrepend,
    CInputGroupText
} from '@coreui/react'
import CIcon from '@coreui/icons-react'
import { useQuery, makeVar } from '@apollo/client';
import {  SEARCH_PROVINCIAL_POLL_MAPS
        } from '../../../../apollo/queries';
import history from '../../../../history'
import SearchResultsProvincialPollMaps from './SearchResultsProvincialPollMaps';
import { ApolloConsumer } from "@apollo/client";
import { SET_SEARCH_RESULTS } from '../../../../redux/actions'
import { useDispatch, useSelector } from 'react-redux';
import { provinceNameToShort } from '../../../../helpers/Utils';

const SearchProvincialPolls = (props) => {
  const [searchResults, setSearchResults] = useState([]);
  const dispatch = useDispatch()
  const showSearchResults = useSelector(state => state.starter.searchResults)


  document.addEventListener('keydown', function(e) {
    if(e.keyCode == 27){
      dispatch({type: SET_SEARCH_RESULTS, searchResults: false})
    }
  });

  document.addEventListener('click', function(e) {
    dispatch({type: SET_SEARCH_RESULTS, searchResults: false})
  });

  const search = async (value, client) => {

      if (value.length > 0) {
        try {
        var datasearch = await client.query({
          query: SEARCH_PROVINCIAL_POLL_MAPS,
          fetchPolicy: "no-cache",
          variables: {
            minor_jurisdiction: provinceNameToShort(props.minj),
            district: value
          }        
        });
        if (datasearch) {
          console.log(datasearch);
          setSearchResults(datasearch);
          dispatch({type: SET_SEARCH_RESULTS, searchResults: true})
        };      
        } catch (e) {
          console.log(e);
        }
      }
  }

    return (
        <div style={{paddingLeft:'1rem'}}>
        <ApolloConsumer>
            {(client) => (       
                <CFormGroup row style={{marginTop:'15px'}}>
                  <CCol md="12">
                    <CInputGroup>
                    <CInputGroupPrepend>
                        <CInputGroupText>
                          <CIcon name="cil-magnifying-glass" />
                        </CInputGroupText>
                      </CInputGroupPrepend>
                      <CInput id="pollmapsearch" onChange={(e) => { search(e.target.value, client) } } placeholder="Search for riding or candidate..." />
                    </CInputGroup>
                  </CCol>
              </CFormGroup>                   
            // <input id="pollmapsearch" onChange={(e) => { search(e.target.value, client) } } type="text" className="form-control" placeholder="Search for riding..." aria-label="Search for riding..." style={{marginBottom:'10px', marginTop:'10px'}} />
            )}
        </ApolloConsumer>
        {searchResults ? <SearchResultsProvincialPollMaps theData={searchResults.data} /> : ""}
        </div>
    )
  }
  
  export default SearchProvincialPolls;